module.exports = __webpack_public_path__ + "static/img/icons8-cloud_link.df89d7a9.svg";